import React, {
  useState, useRef, useEffect, useCallback
} from 'react';
import PropTypes from 'prop-types';

export default function TabbedCarousel({ images = [], autoplay = 0 }) {
  /* ---------- 正規化 ---------- */
  const slides = images.map(img =>
    typeof img === 'string' ? { src: img, alt: '' } : img
  );

  /* ---------- refs と state ---------- */
  const sliderRef = useRef(null);
  const slideRefs = useRef([]);
  const [active, setActive] = useState(0);

  /* ---------- コールバック ref (固定) ---------- */
  const setSlideRef = useCallback((idx) => (el) => {
    if (el) slideRefs.current[idx] = el;
  }, []);

  /* ---------- スクロールして中央へ ---------- */
  const goTo = useCallback((idx) => {
    const slider = sliderRef.current;
    const slide  = slideRefs.current[idx];
    if (!slider || !slide) return;

    const offset =
      slide.offsetLeft + slide.offsetWidth / 2 - slider.clientWidth / 2;

    slider.scrollTo({ left: offset, behavior: 'smooth' });
    setActive(idx);
  }, []);

  /* ---------- 自動再生 ---------- */
  useEffect(() => {
    if (!autoplay || slides.length < 1) return undefined;
    const id = setInterval(
      () => goTo((active + 1) % slides.length),
      autoplay
    );
    return () => clearInterval(id);
  }, [autoplay, active, slides.length, goTo]);

  if (slides.length === 0) return null;

  /* ---------- JSX ---------- */
  return (
    <div className="tc">
      <div className="tc__slider" ref={sliderRef}>
        {slides.map((img, idx) => (
          <div
            key={idx}
            className="tc__slide"
            ref={setSlideRef(idx)}         
          >
            <img src={img.src} alt={img.alt} loading="lazy" />
          </div>
        ))}
      </div>

      <div className="tc__dots">
        {slides.map((_, idx) => (
          <button
            key={idx}
            className={`tc__dot ${idx === active ? 'is-active' : ''}`}
            onClick={() => goTo(idx)}
          />
        ))}
      </div>
    </div>
  );
}

TabbedCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string }),
    ])
  ).isRequired,
  autoplay: PropTypes.number,
};
